(function () {
  function groupSlideContent(slide) {
    var content = slide.querySelector('.stress-calculator__slide-content');
    if (!content || content.dataset.scGrouped === '1') return;

    var imagesByIndex = {};
    Array.prototype.forEach.call(
      content.querySelectorAll('.sc-content-image'),
      function (img) {
        var m = img.className.match(/sc-content-image--(\d+)(?:\s|$)/);
        if (m) {
          if (!imagesByIndex[m[1]]) imagesByIndex[m[1]] = [];
          imagesByIndex[m[1]].push(img);
        }
      }
    );

    Array.prototype.forEach.call(
      content.querySelectorAll(':scope > p'),
      function (p) {
        var m = p.textContent.trim().match(/^\[content image (\d+)\]$/i);
        if (!m) return;
        var imgs = imagesByIndex[m[1]];
        if (imgs && imgs.length) {
          imgs.forEach(function (img) {
            content.insertBefore(img, p);
            img.dataset.scPlaced = '1';
          });
          p.remove();
        } else {
          p.remove();
        }
      }
    );

    var allChildren = Array.prototype.slice.call(content.children);
    var contentImages = allChildren.filter(function (n) {
      return n.classList && n.classList.contains('sc-content-image') && n.dataset.scPlaced !== '1';
    });
    var children = allChildren.filter(function (n) {
      return !(n.classList && n.classList.contains('sc-content-image') && n.dataset.scPlaced !== '1');
    });

    function isSeparator(node) {
      if (!node || node.tagName !== 'P') return false;
      return node.textContent.replace(/\s+/g, '') === '--';
    }
    function hasLeadingMarker(node) {
      if (!node || node.tagName !== 'P') return false;
      return /^\s*--\s*(<br|\n|\r)/i.test(node.innerHTML);
    }

    var hasMarker = children.some(function (n) {
      return isSeparator(n) || hasLeadingMarker(n);
    });
    if (!hasMarker) return;

    var groups = [[]];
    children.forEach(function (n) {
      if (isSeparator(n)) {
        if (groups[groups.length - 1].length > 0) groups.push([]);
      } else if (hasLeadingMarker(n)) {
        if (groups[groups.length - 1].length > 0) groups.push([]);
        n.innerHTML = n.innerHTML
          .replace(/^\s*--\s*<br\s*\/?>/i, '')
          .replace(/^\s*--\s*/, '');
        groups[groups.length - 1].push(n);
      } else {
        groups[groups.length - 1].push(n);
      }
    });

    content.innerHTML = '';
    content.classList.add('sc-grouped');
    content.dataset.scGrouped = '1';

    var idx = 0;
    groups.forEach(function (nodes) {
      if (nodes.length === 0) return;
      var div = document.createElement('div');
      div.className = 'sc-group';
      div.dataset.group = String(idx);
      nodes.forEach(function (n) { div.appendChild(n); });
      content.appendChild(div);
      idx++;
    });
    content.dataset.scGroupCount = String(idx);

    contentImages.forEach(function (img) {
      var target = img.dataset.targetGroup;
      var targetGroup = content.querySelector('.sc-group[data-group="' + target + '"]');
      if (!targetGroup) {
        content.appendChild(img);
        return;
      }
      var firstP = targetGroup.querySelector(':scope > p');
      if (firstP) {
        if (firstP.nextSibling) {
          targetGroup.insertBefore(img, firstP.nextSibling);
        } else {
          targetGroup.appendChild(img);
        }
      } else {
        targetGroup.insertBefore(img, targetGroup.firstChild);
      }
    });
  }

  function init(root) {
    var track = root.querySelector('[data-sc-track]');
    var handle = root.querySelector('[data-sc-handle]');
    var slideWrap = root.querySelector('[data-sc-slides]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sc-slide]'));
    if (!track || !handle || slides.length === 0) return;

    slides.forEach(groupSlideContent);

    var count = slides.length;
    var activeIndex = 0;
    var barDragging = false;
    var ignoreScroll = false;
    var ignoreScrollTimer = null;
    var settleTimer = null;

    function clampIdx(i) {
      return Math.max(0, Math.min(count - 1, i));
    }

    function positionForIndex(i) {
      if (count <= 1) return 50;
      return (i / (count - 1)) * 100;
    }

    function nearestIndex(percent) {
      if (count <= 1) return 0;
      return clampIdx(Math.round((percent / 100) * (count - 1)));
    }

    function isVertical() {
      return track.offsetHeight > track.offsetWidth;
    }

    function percentFromClient(clientX, clientY) {
      var rect = track.getBoundingClientRect();
      if (isVertical()) {
        if (rect.height === 0) return 0;
        return Math.max(0, Math.min(100, ((clientY - rect.top) / rect.height) * 100));
      }
      if (rect.width === 0) return 0;
      return Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    }

    function setHandlePos(pct) {
      handle.style.setProperty('--sc-handle-pos', pct + '%');
    }

    function applyActiveState() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === activeIndex);
      });
      root.classList.toggle('is-past-first', activeIndex > 0);
    }

    function paint() {
      setHandlePos(positionForIndex(activeIndex));
      applyActiveState();
    }

    function setIndex(i) {
      i = clampIdx(i);
      if (i === activeIndex) return;
      activeIndex = i;
      paint();
    }

    function scrollToActive() {
      if (!slideWrap || !slides[activeIndex]) return;
      ignoreScroll = true;
      if (isVertical()) {
        slideWrap.scrollTo({ top: slides[activeIndex].offsetTop, behavior: 'smooth' });
      } else {
        slideWrap.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: 'smooth' });
      }
      if (ignoreScrollTimer) clearTimeout(ignoreScrollTimer);
      ignoreScrollTimer = setTimeout(function () { ignoreScroll = false; }, 600);
    }

    function onHandleDown(e) {
      e.preventDefault();
      e.stopPropagation();
      barDragging = true;
      handle.classList.add('is-dragging');
      try { handle.setPointerCapture(e.pointerId); } catch (_) {}
      var pct = percentFromClient(e.clientX, e.clientY);
      setHandlePos(pct);
      var idx = nearestIndex(pct);
      if (idx !== activeIndex) {
        activeIndex = idx;
        applyActiveState();
      }
    }

    function onHandleMove(e) {
      if (!barDragging) return;
      var pct = percentFromClient(e.clientX, e.clientY);
      setHandlePos(pct);
      var idx = nearestIndex(pct);
      if (idx !== activeIndex) {
        activeIndex = idx;
        applyActiveState();
      }
    }

    function onHandleUp(e) {
      if (!barDragging) return;
      barDragging = false;
      handle.classList.remove('is-dragging');
      try { handle.releasePointerCapture(e.pointerId); } catch (_) {}
      setHandlePos(positionForIndex(activeIndex));
      scrollToActive();
    }

    handle.addEventListener('pointerdown', onHandleDown);
    handle.addEventListener('pointermove', onHandleMove);
    handle.addEventListener('pointerup', onHandleUp);
    handle.addEventListener('pointercancel', onHandleUp);

    track.addEventListener('pointerdown', function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      setIndex(nearestIndex(percentFromClient(e.clientX, e.clientY)));
      scrollToActive();
    });

    if (slideWrap) {
      slideWrap.addEventListener('scroll', function () {
        if (barDragging || ignoreScroll) return;
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          if (isVertical()) {
            var h = slideWrap.clientHeight;
            if (h === 0) return;
            setIndex(Math.round(slideWrap.scrollTop / h));
          } else {
            var w = slideWrap.clientWidth;
            if (w === 0) return;
            setIndex(Math.round(slideWrap.scrollLeft / w));
          }
        }, 80);
      }, { passive: true });
    }

    paint();

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-in-view');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      io.observe(root);
    } else {
      root.classList.add('is-in-view');
    }
  }

  function boot() {
    document.querySelectorAll('[data-stress-calculator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-stress-calculator]');
    if (root) init(root);
  });
})();
